import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import EducationalPrograms from '../components/EducationalPrograms';
import Benefits from '../components/Benefits';

const Service: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="main-wrapper">
            {/* Hero Banner Section */}
            <div className="section-hero-banar is-services">
                <div className="padding-global">
                    <div className="container-large">
                        <div className="padding-section-medium">
                            <div className="hero-banner-component">
                                <div className="hero-banner-content-wrapper">
                                    <h2 className="heading-style-h2">{t('service.heroTitle', 'Growth You Can See')}</h2>
                                    <div className="hero-banar-content">
                                        <Link to="/" className="home-link">
                                            {t('navbar.home', 'Home')}
                                        </Link>
                                        <div className="hero-banar-dot dot-color-yello"></div>
                                        <div className="hero-banar-text text-color-yello">
                                            {t('navbar.service', 'Features')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Educational Programs Section - Same as Home page */}
            <EducationalPrograms />

            {/* Benefits Section - Same as Home page */}
            <Benefits />
        </div>
    );
};

export default Service;
